import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useCurrency } from '../../hooks/useCurrency';

import Table from "../../core/pagination/datatable";
import {
  Modal,
  Button,
  Select,
  Input,
  notification,
  InputNumber,
  Space,
} from "antd";
import {
  fetchUsers,
  editUser,
  removeUser,
  openModal,
  closeModal,
  openDeleteModal,
  closeDeleteModal,
  selectFilteredAccessibleUsers,
  attachUserToCustomer,
} from "../../core/redux/user.slice";
import {
 // fetchActiveCompany,
  configureCompanyPoints,
} from "../../core/redux/company.slice";
import { fetchCustomers } from "../../core/redux/customer.slice";
import {
  addUserPoint,
  addUserPointsBulk,
  softRemoveUserPoint,
} from "../../core/redux/userpoint.slice";
import { useShopId } from "../../hooks/useShopId";
import UserFormModal from "../../core/modals/peoples/UserFormModal";
import ChangePasswordModal from "../../core/modals/peoples/ChangePasswordModal";
import Tag from "../../core/common/tag";
import { canSee } from "../../core/utils/permissions";
import axios from "../../core/utils/axios.wrapper";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import dayjs from "dayjs";
import CommonFooter from "../../core/common/footer/commonFooter";
import LoadingState from "../../core/common/LoadingState";
import StickyBar from "../../core/common/StickyBar";
import { usePrintContext } from "../../core/utils/printContext";

const { Option } = Select;
const { confirm } = Modal;
const fallbackUserImage = "/assets/img/users/user-00.png";
const Users = () => {
  const { t } = useTranslation();
    const currency = useCurrency();
  const dispatch = useDispatch();
  const { shopId } = useShopId();
  const users = useSelector((state) =>
    selectFilteredAccessibleUsers(state, shopId),
  );
  const { loading, showModal, showDeleteModal } = useSelector(
    (state) => state.user,
  );
  const { getPdfColor } = usePrintContext();
  const { user } = useSelector((state) => state.auth);
  const customers = useSelector((state) => state.customer.customers);
  const { loading: customerLoading } = useSelector((state) => state.customer);
  const canDelete =
    canSee(user?.roles, "SUPERADMIN") || canSee(user?.roles, "ADMIN");
  // States existants

  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [userForPasswordChange, setUserForPasswordChange] = useState(null);
  const [isReadMode, setIsReadMode] = useState(false);
  const [filters, setFilters] = useState({
    role: "",
    searchText: "",
  });
  // Nouveaux states pour attachement client

  const [showAttachClientModal, setShowAttachClientModal] = useState(false);
  const [userToAttach, setUserToAttach] = useState(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  // Modal LGTS (création compte individuel après attach)

  const [showCreateLgtsModal, setShowCreateLgtsModal] = useState(false);
  const [initialBalance, setInitialBalance] = useState("");
  const [lgtsEmployee, setLgtsEmployee] = useState(null);
  // Modal Attribution LGTS (massif)

  const [showLgtsAttributionModal, setShowLgtsAttributionModal] =
    useState(false);
  const [lgtsYear, setLgtsYear] = useState(null);
  const [lgtsMonth, setLgtsMonth] = useState(null);
  const [lgtsAmount, setLgtsAmount] = useState("");
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [lgtsSearchText, setLgtsSearchText] = useState("");

  const [showCompanyPointsModal, setShowCompanyPointsModal] = useState(false);
  const [companyPoints, setCompanyPoints] = useState(0);
  const [pointsLoading, setPointsLoading] = useState(false);
  // AJOUTER le company selector

  const activeCompany = useSelector((state) => state.company.company);
 // const companyLoading = useSelector((state) => state.company.loading);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleAttachToClient = (user) => {
    dispatch(fetchCustomers());
    setUserToAttach(user);
    // S'il a déjà un customerId, on le met comme valeur sélectionnée

    if (user.customerId) {
      setSelectedCustomerId(user.customerId);
    } else {
      setSelectedCustomerId(null);
    }
    setShowAttachClientModal(true);
  };

  const handleCustomerChange = (customerId) => {
    setSelectedCustomerId(customerId);
  };

  const handleAttachCustomer = async () => {
    if (!selectedCustomerId || !userToAttach) {
      console.error("Client ou utilisateur non sélectionné");
      return;
    }

    try {
      await dispatch(
        attachUserToCustomer({
          userId: userToAttach.id,
          customerId: selectedCustomerId,
        }),
      ).unwrap();

      notification.success({
        message: t("users.notifications.userAttachSuccess"),
        description: t("users.notifications.userAttachSuccessDesc"),
      });
      await dispatch(fetchUsers());
      // Fermer le modal d’attachement

      setShowAttachClientModal(false);
      // Préparer le popup LGTS

      // setInitialBalance("");
      // setLgtsEmployee(userToAttach);
      // setShowCreateLgtsModal(true);
    } catch (error) {
      console.error("Erreur lors de l'attachement:", error);
      notification.error({
        message: t("users.notifications.userAttachError"),
        description: t("users.notifications.userAttachErrorDesc"),
      });
    }
  };
  // Charger les points de la société active

  // const loadCompanyPoints = async () => {
  //   if (!activeCompany?.id) {
  //     try {
  //       const company = await dispatch(fetchActiveCompany()).unwrap();
  //       setCompanyPoints(company?.pointsMonthlyAmount || 0);
  //     } catch (error) {
  //       notification.error({
  //         message: t("users.notifications.pointsConfigError"),
  //         description: t("users.notifications.pointsConfigWarning"),
  //       });
  //     }
  //   } else {
  //     setCompanyPoints(activeCompany?.pointsMonthlyAmount || 0);
  //   }
  // };
  // Configurer les points

  const handleConfigurePoints = async () => {
    if (!activeCompany?.companyId || !companyPoints || companyPoints < 0) {
      notification.warning({
        message: t("users.notifications.pointsConfigWarning"),
        description: t("users.notifications.pointsConfigWarningDesc"),
      });
      return;
    }

    setPointsLoading(true);
    try {
      await dispatch(
        configureCompanyPoints({
          id: activeCompany.companyId,
          points: Number(companyPoints),
        }),
      ).unwrap();

      notification.success({
        message: t("users.notifications.pointsConfigSuccess"),
        description: t("users.notifications.pointsConfigSuccessDesc", {
          count: companyPoints,
        }),
      });

      setShowCompanyPointsModal(false);
    } catch (error) {
      notification.error({
        message: t("users.notifications.pointsConfigError"),
        description: t("users.notifications.pointsConfigErrorDesc"),
      });
    } finally {
      setPointsLoading(false);
    }
  };

  const handleAdd = () => {
    setIsEditMode(false);
    setSelectedUser(null);
    dispatch(openModal());
  };

  const handleEdit = (user) => {
    setIsEditMode(true);
    setIsReadMode(false);
    setSelectedUser(user);
    dispatch(openModal());
  };

  // const handleView = (user) => {
  //   setIsReadMode(true);
  //   setIsEditMode(true);
  //   setSelectedUser(user);
  //   dispatch(openModal());
  // };

  const handleChangePassword = (user) => {
    setUserForPasswordChange(user);
    setShowChangePasswordModal(true);
  };

  const handleCancel = () => {
    setIsReadMode(false);
    dispatch(closeModal());
  };

  const handleChangePasswordCancel = () => {
    setShowChangePasswordModal(false);
    setUserForPasswordChange(null);
  };

  const handlePrintUsers = () => {
    if (!filteredUsers || filteredUsers.length === 0) {
      notification.warning({
        message: t("users.list.nothingToPrint"),
        description: t("users.notifications.noUsersToPrint"),
      });
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const marginLeft = 15;
    const marginRight = 15;
    const marginTop = 15;
    const pageWidth = doc.internal.pageSize.getWidth();
    const contentWidth = pageWidth - marginLeft - marginRight;
    // Titre

    doc.setFont("Helvetica", "bold");
    doc.setFontSize(18);
    doc.text(t("users.print.title"), marginLeft, marginTop);
    // Sous-titre : date + filtres

    doc.setFontSize(10);
    doc.setFont("Helvetica", "normal");
    const now = dayjs().format("DD/MM/YYYY HH:mm");
    doc.text(
      `${t("users.print.printedDate")} ${now}`,
      marginLeft,
      marginTop + 7,
    );

    const filterTexts = [];
    if (filters.role) {
      const roleLabel = t(`users.roles.${filters.role}`) || filters.role;
      filterTexts.push(`${t("users.print.roleLabel")} ${roleLabel}`);
    }
    if (filters.searchText) {
      filterTexts.push(
        `${t("users.print.searchLabel")} "${filters.searchText}"`,
      );
    }

    if (filterTexts.length > 0) {
      doc.text(filterTexts.join(" | "), marginLeft, marginTop + 12);
    }
    // Données du tableau

    const body = filteredUsers.map((u) => {
      const fullName = [u.firstName, u.lastName].filter(Boolean).join(" ");
      const roles = u.roles && Array.isArray(u.roles) ? u.roles.join(", ") : "";
      const shops =
        u.shopNames && Array.isArray(u.shopNames) ? u.shopNames.join(", ") : "";
      // Solde LGTS (même logique que ta colonne table)

      let lgtsLabel = "-";
      if (u.lgts && u.lgts.length > 0) {
        const sorted = [...u.lgts].sort((a, b) => {
          if (a.forYear !== b.forYear) return b.forYear - a.forYear;
          return b.forMonth - a.forMonth;
        });
        const last = sorted[0];
        const { forMonth, forYear, cumulatedValue } = last || {};

        if ((forMonth === 0 || !forMonth) && (forYear === 0 || !forYear)) {
          lgtsLabel = `${t("users.lgts.initialBalance")} : ${cumulatedValue ?? 0}${currency.symbol}`;
        } else {
          const monthLabel = t(`users.lgts.months.${forMonth}`) || forMonth;
          lgtsLabel = `${monthLabel} ${forYear} : ${cumulatedValue ?? 0} ${currency.symbol}`;
        }
      }

      const customerName = u.customerName || "";

      return [
        fullName || "-",
        u.phone || "-",
        u.email || "-",
        roles || "-",
        shops || "-",
        lgtsLabel,
        customerName || "-",
      ];
    });
    // Tableau

    autoTable(doc, {
      startY: marginTop + 18,
      head: [
        [
          t("users.print.headers.user"),
          t("users.print.headers.phone"),
          t("users.print.headers.email"),
          t("users.print.headers.roles"),
          t("users.print.headers.pdv"),
          t("users.print.headers.lgtsBalance"),
          t("users.print.headers.attachedClient"),
        ],
      ],
      body,
      margin: { left: marginLeft, right: marginRight },
      styles: {
        font: "Helvetica",
        fontSize: 9,
        cellPadding: 2,
        valign: "middle",
      },
      headStyles: {
        fillColor: getPdfColor("primary"),
        textColor: 255,
        halign: "center",
      },
      columnStyles: {
        0: { cellWidth: contentWidth * 0.2 },
        1: { cellWidth: contentWidth * 0.12 },
        2: { cellWidth: contentWidth * 0.2 },
        3: { cellWidth: contentWidth * 0.15 },
        4: { cellWidth: contentWidth * 0.12 },
        5: { cellWidth: contentWidth * 0.12 },
        6: { cellWidth: contentWidth * 0.09 },
      },
      theme: "striped",
    });
    // Lancement impression

    doc.autoPrint();
    const blobUrl = doc.output("bloburl");
    window.open(blobUrl);
  };

  const deleteUser = () => {
    dispatch(removeUser(userToDelete));
  };

  const createUser = async (user) => {
    const { data } = await axios.post("/user/create", user);
    return data;
  };

  const handleFormSubmit = async (values, cb) => {
    if (isEditMode) {
      dispatch(editUser({ id: selectedUser.id, user: values }))
        .unwrap()
        .then(() => {
          notification.success({
            message: t("users.notifications.userModifySuccess"),
            description: t("users.notifications.userModifySuccessDesc"),
          });
          handleCancel();
        })
        .catch((error) => {
          console.error("Error updating user:", error);
          notification.error({
            message: t("users.notifications.userModifyError"),
            description:
              error?.response?.data?.message ||
              t("users.notifications.userModifyErrorDesc"),
          });
        });
    } else {
      try {
        const user = await createUser(values);
        notification.success({
          message: t("users.notifications.userCreateSuccess"),
          description: t("users.notifications.userCreateSuccessDesc"),
        });
        cb(user);
        dispatch(fetchUsers());
        handleCancel();
      } catch (error) {
        console.error("Error creating user:", error);
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          t("users.notifications.userCreateErrorDesc");

        notification.error({
          message: t("users.notifications.userCreateError"),
          description: errorMessage,
        });
      }
    }
  };
  // Tooltips pour les actions

  // const renderViewTooltip = (props) => (
  //   <Tooltip id="view-tooltip" {...props}>
  //     {t("users.tooltips.view")}
  //   </Tooltip>
  // );

  const renderEditTooltip = (props) => (
    <Tooltip id="edit-tooltip" {...props}>
      {t("common.edit")}
    </Tooltip>
  );

  const renderPasswordTooltip = (props) => (
    <Tooltip id="password-tooltip" {...props}>
      {t("users.tooltips.changePassword")}
    </Tooltip>
  );

  const renderAttachTooltip = (props) => (
    <Tooltip id="attach-tooltip" {...props}>
      {t("users.tooltips.attachToClient")}
    </Tooltip>
  );

  const renderDeleteTooltip = (props) => (
    <Tooltip id="delete-tooltip" {...props}>
      {t("common.delete")}
    </Tooltip>
  );

  const filteredUsers = users.filter((user) => {
    if (!user.isActive) return false;

    const roleMatch =
      !filters.role ||
      (user.roles && user.roles.some((role) => role === filters.role));

    const searchMatch =
      !filters.searchText ||
      (user.firstName &&
        user.firstName
          .toLowerCase()
          .includes(filters.searchText.toLowerCase())) ||
      (user.lastName &&
        user.lastName
          .toLowerCase()
          .includes(filters.searchText.toLowerCase())) ||
      (user.phone &&
        user.phone.toLowerCase().includes(filters.searchText.toLowerCase()));

    return roleMatch && searchMatch;
  });

  const roleOptions = [
    { value: "ADMIN", label: t("users.roles.ADMIN") },
    { value: "MANAGER", label: t("users.roles.MANAGER") },
    { value: "ASSISTANT MANAGER", label: t("users.roles.ASSISTANT MANAGER") },
    { value: "PRODUCTION MANAGER", label: t("users.roles.PRODUCTION MANAGER") },
    { value: "SELLER", label: t("users.roles.SELLER") },
  ];

  const columns = [
    {
      title: t("users.columns.user"),
      dataIndex: "firstName",
      render: (_, record) => {
        const userPhotos = (record.photos || []).filter((p) => p.userId);

        const userPhotoUrl =
          userPhotos.find((p) => p.isPrincipal)?.presignedUrl ||
          userPhotos[userPhotos.length - 1]?.presignedUrl ||
          fallbackUserImage;

        return (
          <span className="userimgname">
            <Link
              to="#"
              onClick={() => handleEdit(record)}
              className="userslist-img bg-img"
            >
              <img
                alt={`${record.firstName} ${record.lastName}`}
                src={userPhotoUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = fallbackUserImage;
                }}
                style={{
                  width: 40,
                  height: 40,
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </Link>
            <div style={{ marginLeft: 10 }}>
              <Link to="#" onClick={() => handleEdit(record)}>
                {record.firstName} {record.lastName}
              </Link>
              {/* <div style={{ fontSize: 10 }}>
                {record.customerName
                  ? record.customerName
                  : t("users.columns.notFound")}
              </div> */}

              <div>
                {record.roles.map((role, i) => (
                  <Tag
                    key={i}
                    color="primary"
                    content={t(`users.roles.${role}`) || role}
                    size="sm"
                    className="me-1"
                  />
                ))}
              </div>
            </div>
          </span>
        );
      },
    },
    {
      title: t("users.columns.phone"),
      dataIndex: "phone",
    },
    {
      title: t("users.columns.email"),
      dataIndex: "email",
    },
    {
      title: t("users.columns.pdv"),
      dataIndex: "shopNames",
      render: (shopNames) => (
        <div className="tag-list">
          {shopNames.map((shop, i) => (
            <Tag key={i} color="secondary" content={shop} size="sm" />
          ))}
        </div>
      ),
    },
    // {
    //   title: t("users.columns.lgtsBalance"),
    //   dataIndex: "lgts",
    //   key: "lgtsBalance",
    //   render: (lgts) => {
    //     if (!lgts || lgts.length === 0) {
    //       return "-";
    //     }

    //     const sorted = [...lgts].sort((a, b) => {
    //       if (a.forYear !== b.forYear) {
    //         return b.forYear - a.forYear;
    //       }
    //       return b.forMonth - a.forMonth;
    //     });

    //     const last = sorted[0];
    //     const { forMonth, forYear, cumulatedValue } = last;

        // if (forMonth === 0 && forYear === 0) {
        //   return (
        //     <div className="d-flex flex-column">
        //       <Tag
        //         color="warning"
        //         content={t("users.lgts.initialBalance")}
        //         size="sm"
        //       />
        //       <span className="fw-bold">{cumulatedValue ?? 0}  {currency.symbol}</span>
        //     </div>
        //   );
        // }

    //     const monthLabel = t(`users.lgts.months.${forMonth}`) || forMonth;

    //     return (
    //       <div className="d-flex flex-column">
    //         <Tag
    //           color="purple"
    //           content={`${monthLabel} ${forYear}`}
    //           size="sm"
    //         />
    //         <span className="fw-bold">{cumulatedValue ?? 0} TND</span>
    //       </div>
    //     );
    //   },
    // },
    {
      title: t("users.columns.actions"),
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            {/* Voir */}

            {/* <OverlayTrigger placement="top" overlay={renderViewTooltip}>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleView(record)}
              >
                <i
                  data-feather="eye"
                  className="feather feather-eye action-eye"
                ></i>
              </Link>
            </OverlayTrigger> */}
            {/* Modifier */}

            <OverlayTrigger placement="top" overlay={renderEditTooltip}>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleEdit(record)}
              >
                <i data-feather="edit" className="feather-edit"></i>
              </Link>
            </OverlayTrigger>
            {/* Changer mot de passe */}

            <OverlayTrigger placement="top" overlay={renderPasswordTooltip}>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => handleChangePassword(record)}
              >
                <i data-feather="key" className="feather feather-settings"></i>
              </Link>
            </OverlayTrigger>
            {/* Attacher à un client */}

            <OverlayTrigger placement="top" overlay={renderAttachTooltip}>
              <span>
                <Link
                  className={`me-2 p-2 ${record.customerId ? "disabled" : ""}`}
                  to="#"
                  onClick={() => {
                    if (record.customerId) return;
                    handleAttachToClient(record);
                  }}
                  style={
                    record.customerId
                      ? { pointerEvents: "none", opacity: 0.5 }
                      : {}
                  }
                >
                  <i data-feather="link" className="feather feather-link"></i>
                </Link>
              </span>
            </OverlayTrigger>
            {/* Supprimer */}
            {canDelete && (
              <OverlayTrigger placement="top" overlay={renderDeleteTooltip}>
                <Link
                  className="confirm-text p-2"
                  to="#"
                  onClick={() => {
                    setUserToDelete(record.id);
                    dispatch(openDeleteModal());
                  }}
                >
                  <i data-feather="trash-2" className="feather-trash-2"></i>
                </Link>
              </OverlayTrigger>
            )}
          </div>
        </div>
      ),
    },
  ];

  const yearOptions = Array.from({ length: 11 }, (_, i) => 2026 + i);
  const monthOptions = [
    { value: 1, label: t("users.lgts.months.1") },
    { value: 2, label: t("users.lgts.months.2") },
    { value: 3, label: t("users.lgts.months.3") },
    { value: 4, label: t("users.lgts.months.4") },
    { value: 5, label: t("users.lgts.months.5") },
    { value: 6, label: t("users.lgts.months.6") },
    { value: 7, label: t("users.lgts.months.7") },
    { value: 8, label: t("users.lgts.months.8") },
    { value: 9, label: t("users.lgts.months.9") },
    { value: 10, label: t("users.lgts.months.10") },
    { value: 11, label: t("users.lgts.months.11") },
    { value: 12, label: t("users.lgts.months.12") },
  ];

  const employeesWithCustomer = filteredUsers
    .filter((u) => !!u.customerId)
    .map((u) => {
      if (!u.lgts || u.lgts.length === 0) {
        return {
          ...u,
          lastForMonth: null,
          lastForYear: null,
          lastCumulatedValue: null,
          lastGrantedAmount: null,
        };
      }

      const sorted = [...u.lgts].sort((a, b) => {
        if (a.forYear !== b.forYear) {
          return b.forYear - a.forYear;
        }
        return b.forMonth - a.forMonth;
      });

      const last = sorted[0];

      return {
        ...u,
        lastForMonth: last.forMonth,
        lastForYear: last.forYear,
        lastCumulatedValue: last.cumulatedValue,
        lastGrantedAmount: last.grantedValue,
      };
    });

  const filteredEmployeesForLgts = employeesWithCustomer.filter((u) => {
    if (!lgtsSearchText) return true;
    const text = lgtsSearchText.toLowerCase();
    const fullName = `${u.firstName ?? ""} ${u.lastName ?? ""}`.toLowerCase();
    const customerName = (u.customerName ?? "").toLowerCase();
    return fullName.includes(text) || customerName.includes(text);
  });

  const lgtsRowSelection = {
    selectedRowKeys: selectedEmployeeIds,
    onChange: (selectedRowKeys) => {
      setSelectedEmployeeIds(selectedRowKeys);
    },
    getCheckboxProps: (record) => {
      const { lastForMonth, lastForYear } = record;
      // Désactiver si la dernière affectation est exactement le mois/année sélectionnés

      const alreadyAttributed =
        lgtsYear != null &&
        lgtsMonth != null &&
        lastForMonth === lgtsMonth &&
        lastForYear === lgtsYear;

      return {
        disabled: alreadyAttributed,
      };
    },
  };

  const lgtsColumns = [
    {
      title: t("users.lgts.lastDistribution"),
      dataIndex: "lastForMonth",
      render: (_, record) => {
        const { lastForMonth, lastForYear, lastGrantedAmount } = record;

        if (lastForMonth == null || lastForYear == null) {
          return "-";
        }

        if (lastForMonth === 0 && lastForYear === 0) {
          return (
            <div className="d-flex flex-column">
              <span>{t("users.lgts.initialBalance")}</span>
              <span className="text-muted">
                {t("users.modal.lgtsAmount")} : {lastGrantedAmount ?? 0}  {currency.symbol}
              </span>
            </div>
          );
        }

        return (
          <div className="d-flex flex-column">
            <span>
              {lastForMonth}/{lastForYear}
            </span>
            <span className="text-muted">
              {t("users.modal.lgtsAmount")} : {lastGrantedAmount ?? 0} {currency.symbol}
            </span>
          </div>
        );
      },
    },
    {
      title: t("users.columns.user"),
      dataIndex: "fullName",
      render: (_, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      title: t("users.modal.attachClientTitle"),
      dataIndex: "customerName",
    },
    {
      title: t("users.columns.lgtsBalance"),
      dataIndex: "lastCumulatedValue",
      render: (value) => (value == null ? "-" : `${value}${currency.symbol}`),
    },
    {
      title: "",
      key: "actions",
      render: (_, record) => {
        const isInitialBalance =
          record.lastForMonth === 0 && record.lastForYear === 0;

        const handleDeleteClick = () => {
          if (isInitialBalance) {
            notification.error({
              message: t("users.notifications.lgtsCantDeleteInitial"),
              description: t("users.notifications.lgtsCantDeleteInitialDesc"),
            });
            return;
          }

          confirm({
            title: t("users.lgts.deleteConfirmTitle"),
            content: t("users.lgts.deleteConfirmDesc"),
            okText: t("common.yes"),
            cancelText: t("common.cancel"),
            okType: "danger",
            onOk: async () => {
              const lastPoint = (record.lgts || []).find(
                (p) =>
                  p.forMonth === record.lastForMonth &&
                  p.forYear === record.lastForYear,
              );
              if (!lastPoint) return;

              try {
                await dispatch(
                  softRemoveUserPoint(lastPoint.userPointId),
                ).unwrap();

                notification.success({
                  message: t("users.notifications.lgtsDeletedSuccess"),
                  description: t("users.notifications.lgtsDeletedSuccessDesc"),
                });

                setSelectedEmployeeIds((prev) =>
                  prev.filter((id) => id !== record.id),
                );

                await dispatch(fetchUsers());
              } catch (e) {
                console.error("Erreur suppression LGTS :", e);
                notification.error({
                  message: t("users.notifications.lgtsDeletedError"),
                  description: t("users.notifications.lgtsDeletedErrorDesc"),
                });
              }
            },
          });
        };

        return (
          <Button
            type="text"
            danger
            disabled={isInitialBalance}
            onClick={handleDeleteClick}
            icon={<i className="ti ti-trash" />}
            style={
              isInitialBalance ? { opacity: 0.4, cursor: "not-allowed" } : {}
            }
          />
        );
      },
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <StickyBar
            title={t("users.list.title")}
            subtitle={t("users.list.subtitle")}
            count={filteredUsers.length}
            actions={
              <Space size="middle">
                <Button className="btn-customized-primary">
                  <Link to="#" onClick={handleAdd}>
                    <i className="ti ti-circle-plus me-1" />
                    {t("users.list.addButton")}
                  </Link>
                </Button>
                <Button
                  className="btn-customized-primary"
                  onClick={handlePrintUsers}
                >
                  <i className="ti ti-printer me-1"></i>
                  {t("users.list.printButton")}
                </Button>

                {/* {(user?.roles?.includes("ADMIN") ||
                  user?.roles?.includes("SUPERADMIN")) && (
                  <>
                    <Button
                      className="btn-customized-primary"
                      onClick={() => setShowLgtsAttributionModal(true)}
                    >
                      <i className="ti ti-arrows-exchange" />
                      {t("users.list.lgtsAttributionButton")}
                    </Button>

                    <Button
                      className="btn-customized-primary"
                      onClick={() => {
                        loadCompanyPoints();
                        setShowCompanyPointsModal(true);
                      }}
                      loading={companyLoading}
                    >
                      <i className="ti ti-settings" />
                      {t("users.list.configurePointsButton")}
                    </Button>
                  </>
                )} */}
              </Space>
            }
          />

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set d-flex align-items-center gap-3 flex-nowrap">
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <Input
                    placeholder={t("users.list.searchPlaceholder")}
                    style={{ width: 320 }}
                    allowClear
                    value={filters.searchText}
                    onChange={(e) =>
                      setFilters({ ...filters, searchText: e.target.value })
                    }
                  />
                </div>
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <Select
                    placeholder={t("users.list.roleFilter")}
                    style={{ width: 200 }}
                    allowClear
                    value={filters.role || undefined}
                    onChange={(value) =>
                      setFilters({ ...filters, role: value || "" })
                    }
                    options={roleOptions}
                  />
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {loading ? (
                  <LoadingState type="section" message={t("common.loadingData")} />
                ) : (
                  <Table columns={columns} dataSource={filteredUsers} />
                  //loading={loading}
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      <UserFormModal
        open={showModal}
        onCancel={handleCancel}
        onSubmit={handleFormSubmit}
        isEdit={isEditMode}
        isReadMode={isReadMode}
        initialData={selectedUser}
        loading={loading}
      />

      <ChangePasswordModal
        open={showChangePasswordModal}
        onCancel={handleChangePasswordCancel}
        userId={userForPasswordChange?.id}
        userName={
          userForPasswordChange
            ? `${userForPasswordChange.firstName} ${userForPasswordChange.lastName}`
            : ""
        }
      />

      <Modal
        onCancel={() => dispatch(closeDeleteModal())}
        open={showDeleteModal}
        footer={null}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                  {t("users.modal.deleteTitle")}
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                  {t("users.modal.deleteMessage")}
                </p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <Button
                    size="large"
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    onClick={() => dispatch(closeDeleteModal())}
                  >
                    {t("common.cancel")}
                  </Button>
                  <Button
                    size="large"
                    type="button"
                    loading={loading}
                    onClick={deleteUser}
                    className="btn btn-submit fs-13 fw-medium p-2 px-3"
                  >
                    {t("common.yes")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title={t("users.modal.attachClientTitle", {
          name: userToAttach
            ? `${userToAttach.firstName} ${userToAttach.lastName}`
            : "",
        })}
        open={showAttachClientModal}
        confirmLoading={customerLoading}
        onCancel={() => {
          setShowAttachClientModal(false);
          setUserToAttach(null);
          setSelectedCustomerId(null);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setShowAttachClientModal(false);
              setUserToAttach(null);
              setSelectedCustomerId(null);
            }}
          >
            {t("common.cancel")}
          </Button>,
          <Button
            key="attach"
            type="primary"
            disabled={!selectedCustomerId || customerLoading}
            loading={customerLoading}
            onClick={handleAttachCustomer}
          >
            {t("users.modal.attachButton")}
          </Button>,
        ]}
      >
        <p>{t("users.modal.attachClientDesc")}</p>
        <div style={{ marginTop: 16 }}>
          <Select
            showSearch
            placeholder={t("users.modal.attachClientTitle")}
            value={selectedCustomerId}
            onChange={handleCustomerChange}
            loading={customerLoading}
            style={{ width: "100%" }}
            filterOption={(input, option) => {
              const text = option.children?.toString().toLowerCase() || "";
              return text.indexOf(input.toLowerCase()) >= 0;
            }}
          >
            {customers.map((customer) => (
              <Option
                key={customer.customerId}
                value={customer.customerId}
                disabled={!!customer.employeeId}
              >
                {customer.customerName} -{" "}
                {customer.customerPhone ?? customer.customerContactPhone}
              </Option>
            ))}
          </Select>
        </div>
      </Modal>

      <Modal
        title={t("users.modal.createLgtsTitle")}
        open={showCreateLgtsModal}
        onCancel={() => {
          setShowCreateLgtsModal(false);
          setInitialBalance("");
          setLgtsEmployee(null);
        }}
        footer={[
          <Button
            key="no"
            onClick={() => {
              setShowCreateLgtsModal(false);
              setInitialBalance("");
              setLgtsEmployee(null);
            }}
          >
            {t("common.no")}
          </Button>,
          <Button
            key="yes"
            type="primary"
            onClick={async () => {
              if (!lgtsEmployee) return;

              const now = new Date();
              const payload = {
                employeeId: lgtsEmployee.id,
                grantDate: now.toISOString(),
                expirationDate: null,
                forMonth: 0,
                forYear: 0,
                grantedValue: Number(initialBalance),
                userPointIsActive: true,
              };

              try {
                await dispatch(addUserPoint(payload)).unwrap();
                notification.success({
                  message: t("users.notifications.lgtsCreatedSuccess"),
                  description: t("users.notifications.lgtsCreatedSuccessDesc"),
                });
              } catch (e) {
                console.error("Erreur création user point LGTS :", e);
                notification.error({
                  message: t("users.notifications.lgtsCreatedError"),
                  description: t("users.notifications.lgtsCreatedErrorDesc"),
                });
              } finally {
                setShowCreateLgtsModal(false);
                setInitialBalance("");
                setLgtsEmployee(null);
              }
            }}
            disabled={initialBalance === ""}
          >
            {t("common.yes")}
          </Button>,
        ]}
      >
        <p>{t("users.modal.createLgtsDesc")}</p>
        <div style={{ marginTop: 16 }}>
          <label className="form-label">
            {t("users.modal.lgtsInitialBalance")}
          </label>
          <Input
            type="number"
            min={0}
            placeholder="Ex: 0.000"
            value={initialBalance}
            onChange={(e) => setInitialBalance(e.target.value)}
          />
        </div>
      </Modal>

      <Modal
        title={t("users.modal.lgtsAttributionTitle")}
        open={showLgtsAttributionModal}
        width={900}
        styles={{
          wrapper: {
            paddingLeft: 250,
          },
        }}
        onCancel={() => {
          setShowLgtsAttributionModal(false);
          setLgtsYear(null);
          setLgtsMonth(null);
          setLgtsAmount("");
          setSelectedEmployeeIds([]);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setShowLgtsAttributionModal(false);
              setLgtsYear(null);
              setLgtsMonth(null);
              setLgtsAmount("");
              setSelectedEmployeeIds([]);
            }}
          >
            {t("common.cancel")}
          </Button>,
          <Button
            key="validate"
            type="primary"
            disabled={
              !lgtsYear ||
              !lgtsMonth ||
              !lgtsAmount ||
              selectedEmployeeIds.length === 0
            }
            style={{ color: "#fff" }}
            onClick={async () => {
              const now = new Date().toISOString();
              const payload = selectedEmployeeIds.map((employeeId) => ({
                employeeId,
                grantDate: now,
                expirationDate: null,
                forMonth: lgtsMonth,
                forYear: lgtsYear,
                grantedValue: Number(lgtsAmount),
                userPointIsActive: true,
              }));

              try {
                await dispatch(addUserPointsBulk(payload)).unwrap();
                notification.success({
                  message: t("users.notifications.lgtsDistributedSuccess"),
                  description: t(
                    "users.notifications.lgtsDistributedSuccessDesc",
                  ),
                });
              } catch (e) {
                console.error("Erreur attribution LGTS bulk :", e);
                notification.error({
                  message: t("users.notifications.lgtsDistributedError"),
                  description: t(
                    "users.notifications.lgtsDistributedErrorDesc",
                  ),
                });
              } finally {
                setShowLgtsAttributionModal(false);
                setLgtsYear(null);
                setLgtsMonth(null);
                setLgtsAmount("");
                setSelectedEmployeeIds([]);
              }
            }}
          >
            {t("users.buttons.distribute")}
          </Button>,
        ]}
      >
        <div className="d-flex gap-3 mb-3">
          <div style={{ minWidth: 150 }}>
            <label className="form-label">{t("users.modal.lgtsYear")}</label>
            <Select
              style={{ width: "100%" }}
              placeholder={t("users.modal.lgtsYear")}
              value={lgtsYear}
              onChange={setLgtsYear}
              options={yearOptions.map((y) => ({ value: y, label: y }))}
            />
          </div>

          <div style={{ minWidth: 180 }}>
            <label className="form-label">{t("users.modal.lgtsMonth")}</label>
            <Select
              style={{ width: "100%" }}
              placeholder={t("users.modal.lgtsMonth")}
              value={lgtsMonth}
              onChange={setLgtsMonth}
              options={monthOptions}
            />
          </div>

          <div style={{ minWidth: 200 }}>
            <label className="form-label">{t("users.modal.lgtsAmount")}</label>
            <Input
              type="number"
              min={0}
              placeholder="Ex: 150"
              value={lgtsAmount}
              onChange={(e) => setLgtsAmount(e.target.value)}
            />
          </div>
        </div>

        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0">{t("users.modal.selectEmployees")}</h6>
            <Input
              placeholder={t("users.modal.searchEmployees")}
              style={{ width: 300 }}
              allowClear
              value={lgtsSearchText}
              onChange={(e) => setLgtsSearchText(e.target.value)}
            />
          </div>
          <Table
            rowKey="id"
            size="small"
            rowSelection={{
              type: "checkbox",
              ...lgtsRowSelection,
            }}
            columns={lgtsColumns}
            dataSource={filteredEmployeesForLgts}
            pagination={{ pageSize: 5 }}
          />
        </div>
      </Modal>

      <Modal
        title={t("users.modal.companyPointsTitle")}
        open={showCompanyPointsModal}
        confirmLoading={pointsLoading}
        onCancel={() => {
          setShowCompanyPointsModal(false);
          setCompanyPoints(0);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setShowCompanyPointsModal(false);
              setCompanyPoints(0);
            }}
          >
            {t("common.cancel")}
          </Button>,
          <Button
            key="save"
            type="primary"
            disabled={!companyPoints || companyPoints < 0 || pointsLoading}
            loading={pointsLoading}
            onClick={handleConfigurePoints}
          >
            {t("common.save")}
          </Button>,
        ]}
      >
        <div>
          <div className="mb-3">
            <label className="form-label mb-1">
              {t("users.modal.companyPointsTitle")} :{" "}
              <strong>
                {activeCompany?.companyName || t("common.loadingData")}
              </strong>
            </label>
            <p className="text-muted small mb-2">
              {t("users.modal.companyPointsId")}:{" "}
              {activeCompany?.companyId || "N/A"}
            </p>
          </div>

          <div>
            <label className="form-label">
              {t("users.modal.companyPointsLabel")}
            </label>
            <InputNumber
              min={0}
              style={{ width: "100%" }}
              value={companyPoints}
              onChange={(value) => setCompanyPoints(value)}
              placeholder="Ex: 150"
              precision={0}
              formatter={(value) => `${value}`}
              parser={(value) => value.replace(/^\s*\D+/, "")}
              addonAfter="points"
            />
            <small className="text-muted">
              {t("users.modal.companyPointsHint")}
            </small>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Users;
